/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { getFieldZoneLayout } from "cms/fields/layout/get-field-zone-layout";
import { EntityFieldDisplay } from "./display";
import { EntityFieldEdit } from "./edit";

const EntityField = (props) => {

    const zoneProps = {
        ...props,
        displayComponent: <EntityFieldDisplay />,
        editComponent: <EntityFieldEdit />,
    };
    return getFieldZoneLayout(zoneProps);
};
EntityField.displayName = "EntityField";
export { EntityField };
